const skipSentence = (skippedRemindedToday, skippedPaused) => {
  if (skippedRemindedToday > 0 && skippedPaused > 0) {
    return 'Participants already reminded today or paused were skipped.'
  }
  if (skippedRemindedToday > 0) {
    return 'Participants already reminded today were skipped.'
  }
  if (skippedPaused > 0) {
    return 'Paused participants were skipped.'
  }
  return ''
}

export const formatStatusReminderToast = ({
  queued = 0,
  skippedRemindedToday = 0,
  skippedPaused = 0,
} = {}) => {
  const skips = skipSentence(skippedRemindedToday, skippedPaused)
  if (queued > 0) {
    const sent =
      queued === 1 ? 'Reminder sent to 1 participant.' : `Reminder sent to ${queued} participants.`
    return skips ? `${sent} ${skips}` : sent
  }
  return skips || 'No eligible participants to remind.'
}
